<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M32 62c16.569 0 30-13.431 30-30C62 15.431 48.569 2 32 2 15.431 2 2 15.431 2 32c0 16.569 13.431 30 30 30zm0 2C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32z"/>
    <path fill="currentColor" d="M25.067 18.667L44.267 32l-19.2 13.333z"/>
</svg>
